import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Index.vue'
import Main from '../views/Main.vue'
import Introduction from '../views/Introduction.vue'
import Info from '../views/Info.vue'
import NewsView from '../views/NewsView.vue'
import Solution from '../views/Solution.vue'
import About from '../views/About.vue'
import Product from '../views/Product.vue'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/',
        name: 'Main',
        component: Main
      },
      {
        path: '/Introduction',
        name: 'Introduction',
        component: Introduction
      },
      {
        path: '/info',
        name: 'Info',
        component: Info
      },
      {
        path: '/solution',
        name: 'Solution',
        component: Solution
      },
      {
        path: '/product',
        name: 'Master',
        component: Product
      },
      {
        path: '/about',
        name: 'About',
        component: About
      },
      {
        path: '/news/:id',
        name: 'NewsView',
        component: NewsView
      }
    ]
  }
]

const router = new VueRouter(
  {
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
      // 如果有存入的位置就会滚到该位置，否者返回到页面顶部
      if (savedPosition) {
        return savedPosition
      } else {
        if (to.hash) {
          return { selector: to.hash }
        }
      }
    },
    routes
  })

export default router
